"use strict";

exports.__esModule = true;
exports.default = exports.CheckedMode = void 0;
var CheckedMode = {
  // 只返回全选数据，包含父节点和子节点
  Full: 0,
  // 返回全部选择字节点和部分选中的父节点
  Half: 1,
  // 只返回选中子节点
  Child: 2,
  // 如果父节点下所有子节点全部选中，只返回父节点
  Shallow: 3
};
exports.CheckedMode = CheckedMode;

var _default =
/*#__PURE__*/
function () {
  function _default(options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        data = _options.data,
        value = _options.value,
        keygen = _options.keygen,
        mode = _options.mode,
        disabled = _options.disabled;
    this.keygen = keygen;
    this.mode = mode;
    this.valueMap = new Map();
    this.events = {};

    this.disabled = disabled || function () {
      return false;
    };

    this.setValue(value);
    this.setData(data);
  }

  var _proto = _default.prototype;

  _proto.bind = function bind(id, update) {
    this.events[id] = update;
  };

  _proto.unbind = function unbind(id) {
    delete this.events[id];
  };

  _proto.setValue = function setValue(value) {
    this.value = value;

    if (value && value !== this.cachedValue) {
      this.initValue();
    }
  };

  _proto.getValue = function getValue() {
    var _this = this;

    var value = [];
    this.valueMap.forEach(function (checked, id) {
      switch (_this.mode) {
        case CheckedMode.Full:
          if (checked === 1) value.push(id);
          break;

        case CheckedMode.Half:
          if (checked >= 1) value.push(id);
          break;

        case CheckedMode.Child:
          if (checked === 1 && _this.pathMap.get(id).children.length === 0) value.push(id);
          break;

        case CheckedMode.Shallow:
          if (checked === 1) {
            var parentChecked = function () {
              var _this$pathMap$get = _this.pathMap.get(id),
                  path = _this$pathMap$get.path;

              var pid = path[path.length - 1];
              if (!pid) return false;
              return _this.valueMap.get(pid) === 1;
            }();

            if (!parentChecked) value.push(id);
          }

          break;

        default:
      }
    });
    this.cachedValue = value;
    return value;
  };

  _proto.setValueMap = function setValueMap(id, checked) {
    this.valueMap.set(id, checked);
    var update = this.events[id];
    if (update) update();
  };

  _proto.set = function set(id, checked, direction) {
    var _this2 = this;

    // self
    if (!this.isDisabled(id)) this.setValueMap(id, checked);

    var _this$pathMap$get2 = this.pathMap.get(id),
        path = _this$pathMap$get2.path,
        children = _this$pathMap$get2.children; // children


    if (direction !== 'asc') {
      children.forEach(function (cid) {
        _this2.set(cid, checked, 'desc');
      });
    } // parent


    if (direction !== 'desc' && path.length > 0) {
      var parentId = path[path.length - 1];
      var parentChecked = checked;
      this.pathMap.get(parentId).children.forEach(function (cid) {
        if (parentChecked !== _this2.valueMap.get(cid)) {
          parentChecked = 2;
        }
      });
      this.set(parentId, parentChecked, 'asc');
    }
  };

  _proto.isDisabled = function isDisabled(id) {
    var node = this.pathMap.get(id);
    if (node) return node.isDisabled;
    return false;
  };

  _proto.get = function get(id) {
    return this.valueMap.get(id);
  };

  _proto.getDataById = function getDataById(id) {
    return this.dataMap.get(id);
  };

  _proto.getPath = function getPath(id) {
    return this.pathMap.get(id);
  };

  _proto.getChecked = function getChecked(id) {
    var value = this.get(id);
    var checked = value === 1;
    if (value === 2) checked = 'indeterminate';
    return checked;
  };

  _proto.getKey = function getKey(data, id, index) {
    if (id === void 0) {
      id = '';
    }

    if (typeof this.keygen === 'function') return this.keygen(data, id);else if (this.keygen) return data[this.keygen];
    return id + (id ? ',' : '') + index;
  };

  _proto.initValue = function initValue(ids, forceCheck) {
    var _this3 = this;

    if (!this.data || !this.value) return undefined;

    if (!ids) {
      ids = [];
      this.pathMap.forEach(function (val, id) {
        if (val.path.length === 0) ids.push(id);
      });
    }

    var checked;
    ids.forEach(function (id) {
      var _this3$pathMap$get = _this3.pathMap.get(id),
          children = _this3$pathMap$get.children;

      if (forceCheck) {
        _this3.setValueMap(id, 1);

        _this3.initValue(children, forceCheck);

        return;
      }

      var childChecked = _this3.value.indexOf(id) >= 0 ? 1 : 0;

      if (childChecked === 1 && _this3.mode !== CheckedMode.Half) {
        _this3.initValue(children, 1);
      } else if (children.length > 0) {
        childChecked = _this3.initValue(children);
      } else {
        childChecked = _this3.value.indexOf(id) >= 0 ? 1 : 0;
      }

      _this3.setValueMap(id, childChecked);

      if (checked === undefined) checked = childChecked;else if (checked !== childChecked) checked = 2;
    });
    return checked;
  };

  _proto.initData = function initData(data, path, disabled, index) {
    var _this4 = this;

    if (index === void 0) {
      index = [];
    }

    var ids = [];
    data.forEach(function (d, i) {
      var id = _this4.getKey(d, path[path.length - 1], i);

      _this4.dataMap.set(id, d);

      var isDisabled = disabled;

      if (!isDisabled && typeof _this4.disabled === 'function') {
        isDisabled = _this4.disabled(d, i);
      }

      var indexPath = [].concat(index, [i]);
      ids.push(id);
      var children = [];

      if (Array.isArray(d.children)) {
        children = _this4.initData(d.children, [].concat(path, [id]), isDisabled, indexPath);
      }

      _this4.pathMap.set(id, {
        children: children,
        path: path,
        isDisabled: isDisabled,
        indexPath: indexPath,
        index: i
      });
    });
    return ids;
  };

  _proto.setData = function setData(data) {
    this.pathMap = new Map();
    this.dataMap = new Map();
    this.data = data;
    if (!data) return;
    this.initData(data, []);
    this.initValue();
  };

  return _default;
}();

exports.default = _default;